/* Dieselino — countdown ticker (dependency-free).
 *
 * Отдельный файл, а не правка app.min.js: тот бандл собирает вендор темы и
 * руками его не трогаем. Разметку рисует Liquid (snippets/slide-countdown.liquid),
 * скрипт только пересчитывает цифры.
 *
 * Дедлайн приходит в data-countdown-end как ISO 8601 со смещением магазина,
 * поэтому оставшееся время считается от абсолютного момента: перевод часов,
 * таймзона посетителя и сон вкладки на результат не влияют.
 */
(function () {
  'use strict';

  var SELECTOR = '[data-countdown]';
  var MINUTE = 60;
  var HOUR = 60 * MINUTE;
  var DAY = 24 * HOUR;

  var items = [];
  var timer = null;

  function pad(value) {
    return value < 10 ? '0' + value : String(value);
  }

  function collect(el) {
    return {
      el: el,
      end: Date.parse(el.dataset.countdownEnd),
      units: el.querySelector('[data-countdown-units]'),
      expired: el.querySelector('[data-countdown-expired]'),
      days: el.querySelector('[data-countdown-days]'),
      hours: el.querySelector('[data-countdown-hours]'),
      minutes: el.querySelector('[data-countdown-minutes]'),
      seconds: el.querySelector('[data-countdown-seconds]')
    };
  }

  function finish(item) {
    if (item.units) item.units.hidden = true;
    if (item.expired) {
      item.expired.hidden = false;
    } else {
      item.el.hidden = true;
    }
  }

  /* Возвращает false, когда таймер отработал и его пора выкинуть из списка. */
  function update(item, now) {
    var left = Math.floor((item.end - now) / 1000);

    if (left <= 0) {
      finish(item);
      return false;
    }

    if (item.days) item.days.textContent = pad(Math.floor(left / DAY));
    if (item.hours) item.hours.textContent = pad(Math.floor(left / HOUR) % 24);
    if (item.minutes) item.minutes.textContent = pad(Math.floor(left / MINUTE) % 60);
    if (item.seconds) item.seconds.textContent = pad(left % 60);

    return true;
  }

  function tick() {
    var now = Date.now();

    items = items.filter(function (item) {
      /* Слайд могли выкинуть из DOM — например перерисовкой секции в редакторе. */
      if (!item.el.isConnected) return false;
      return update(item, now);
    });

    if (!items.length && timer) {
      clearInterval(timer);
      timer = null;
    }
  }

  function init(root) {
    var elements = (root || document).querySelectorAll(SELECTOR);

    Array.prototype.forEach.call(elements, function (el) {
      if (el.dataset.countdownBound) return;
      el.dataset.countdownBound = 'true';

      var item = collect(el);

      if (isNaN(item.end)) {
        /* Дату не разобрать — прячем таймер, чтобы не висели нули. */
        el.hidden = true;
        console.warn('[sf-countdown] Invalid data-countdown-end:', el.dataset.countdownEnd);
        return;
      }

      if (!update(item, Date.now())) return;

      items.push(item);

      if (!timer) timer = setInterval(tick, 1000);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  /* Редактор тем перерисовывает секцию целиком — цепляем таймеры заново. */
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
